(function (global) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

    global.btoa = global.btoa || function (input = "") {
        let str = String(input);
        let output = "";

        for (
            let block = 0, charCode, idx = 0, map = chars;
            str.charAt(idx | 0) || (map = "=", idx % 1);
            output += map.charAt(63 & (block >> (8 - (idx % 1) * 8)))
        ) {
            charCode = str.charCodeAt((idx += 3 / 4));

            if (charCode > 0xff) {
                throw new Error("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
            }

            block = (block << 8) | charCode;
        }

        return output;
    };

    global.atob = global.atob || function (input = "") {
        let str = String(input).replace(/=+$/, "");
        if (str.length % 4 === 1) {
            throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
        }

        let output = "";
        for (
            let bc = 0, bs, buffer, idx = 0;
            (buffer = str.charAt(idx++));
            ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
                ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
                : 0
        ) {
            buffer = chars.indexOf(buffer);
        }

        return output;
    };
})(typeof window !== "undefined" ? window : global);



class SnnhUtils {
    type(value) {
        if ( this.isSnnh(value)) return "snnh";
        else if (this.isArray(value)) return "array";
        else if (this.isString(value)) return "string";
        else if (this.isNumber(value)) return "number";
        else if (this.isObject(value)) return "object";
        else return "other";
    }

    get date() {
        return this.toDateString();
    }

    get current() {
        return this.toDatetimeString();
    }

    pad (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    replaceAll(str, from, to) {
        if(!str) return str;
        return str.split(from).join(to);
    }

    filesize(bytes) {
        const exp = Math.log(bytes) / Math.log(1024) | 0;
        const result = (bytes / Math.pow(1024, exp)).toFixed(2);
        return result + (exp === 0 ? 'B': 'KMGTPEZY'[exp - 1] + 'B');
    }

    isSnnh(el) {
        return el && el instanceof $Snnh;
    }

    isNumber(args) {
        return Number.isInteger(args);
    }

    isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    isArray(args) {
        return Array.isArray(args)
    }

    isString(args) {
        return typeof args === 'string' || args instanceof String;
    }

    isObject(args) {
        if (args === null) return false;
        return ((typeof args === 'function') || (typeof args === 'object'));
    }

    isFunction(fn) {
        return fn && {}.toString.call(fn) === "[object Function]";
    }

    isBlob(category) {
        if (typeof Blob === "undefined") return false;
        return category instanceof Blob || Object.prototype.toString.call(category) === "[object Blob]";
    }

    isUrl(string) {
        const res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);
        return (res !== null)
    }

    dummyArray(count = 5) {
        return Array.apply(null, { length: count }).map(function(_, index) {
            return index;
        });
    }

    toBufferFromString(string) {
        const buffer = new ArrayBuffer(string.length * 2);
        const bufferView = new Uint16Array(buffer);
        for (let i = 0; i < string.length; i++) {
            bufferView[i] = string.charCodeAt(i);
        }
        return buffer;
    }

    toStringFromBuffer(buffer) {
        return String.fromCharCode.apply(null, buffer);
    }

    toDate(datetime) {
        try {
            return new Date(datetime.replace(/-/g, '/').toString());
        } catch (e) {}
        return null;
    }

    toTime(time) {
        let h, m, s, result='';
        h = Math.floor(time / 3600);
        time -= h * 3600;
        if(h) result = h < 10 ? '0' + h + ':': h + ':';
        m = Math.floor(time / 60);
        time -= m * 60;
        result += m < 10 ? '0' + m + ':': m + ':';
        s = time % 60;
        result += s < 10 ? '0' + s: s;
        return result;
    }

    toDatetimeString(date=null) {
        if(!date) date = new Date();
        date.setHours(date.getHours() + 9);
        return date.toISOString().replace('T', ' ').substring(0, 19);
    }

    toDateString(date=null, glue='-') {
        if(!date) date = new Date();
        return `${this.pad(date.getFullYear(), 4)}${glue}${this.pad((date.getMonth() + 1), 2)}${glue}${this.pad(date.getDate(), 2)}`;
    }

    toDateShort(date, korean=false) {
        if(!date) date = new Date();
        const month_glue = korean ? '월 ' : '-';
        const day_glue = korean ? '일' : '';
        return `${this.pad((date.getMonth() + 1), 2)}${month_glue}${this.pad(date.getDate(), 2)}${day_glue}`;
    }

    toWeekString(date, korean=false) {
        if(!date) date = new Date();
        switch (date.getDay()) {
            case 0:
            default: return korean ? '일' : 'Sun';
            case 1: return korean ? '월' : 'Mon';
            case 2: return korean ? '화' : 'Tue';
            case 3: return korean ? '수' : 'Wed';
            case 4: return korean ? '목' : 'Thu';
            case 5: return korean ? '금' : 'Fri';
            case 6: return korean ? '토' : 'Sat';
        }
    }

    toPrice(number) {
        const reg = /(^[+-]?\d+)(\d{3})/;
        number = String(number);
        while (reg.test(number)) number = number.replace(reg, '$1,$2');
        return number;
    }

    ignoreEvents(e) {
        if(e) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    base64Encode(str) {
        try {
            // noinspection JSDeprecatedSymbols
            return btoa(unescape(encodeURIComponent(str)));
        } catch (e) {}
        return str;
    }

    base64Decode(str) {
        try {
            // noinspection JSDeprecatedSymbols
            return decodeURIComponent(escape(atob(str)));
        } catch (e) {}
        return str;
    }

    build_json(category) {
        let json = {};
        if(category instanceof FormData) {
            category.forEach((value, key) => json[key] = value);
        } else json = category;
        return json;
    }

    build_query(category) {
        // noinspection JSCheckFunctionSignatures
        return new URLSearchParams(this.build_formdata(category)).toString()
    }

    build_formdata(category) {
        const params = new FormData();
        if(!!category) {
            if(category instanceof FormData) return category;
            else {
                Object.keys(category).forEach(key => {
                    const value = category[key];
                    params.set(key, value);
                });
            }
        }
        return params;
    }

    sleep(callback, timeout=0) {
        return setTimeout(callback, timeout);
    }

    unsleep(interval) {
        return clearInterval(interval);
    }

    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    nl2br(str) {
        return str == null ? str : str.replace(/\n/g, "<br />");
    }

    get unique() {
        return "_xxxxxxxxx".replace(/[xy]/g, c => {
            let r = Math.random() * 16 | 0;
            let v = c === "x" ? r : ((r & 3) | 8);
            return v.toString(16);
        });
    }

    ready(callback) {
        window.addEventListener("DOMContentLoaded", e => callback.call(this, e));
    }

    extend(...args) {
        if(args && args.length) {
            $shutils.each(args, arg => Object.assign($sh, arg));
        }
    }

    each(datas, callback) {
        try {
            if(datas && datas.length) datas.forEach(callback);
        } catch (e) {}
    }

    attribute(el) {
        return new SnnhAttribute(el);
    }

    dataset(el) {
        return new SnnhDataset(el);
    }

    property(el) {
        return new SnnhProperty(el);
    }

    class(el) {
        return new SnnhClass(el);
    }

    style(el) {
        return new SnnhStyle(el);
    }

    event(el) {
        return new SnnhEvent(el);
    }

    create(tag, option) {
        let el = document.createElement(tag);
        if(option) {
            // 자식 엘리먼트
            if(option.hasOwnProperty("children")) {
                $shutils.child(el, option.children);
            }

            // 아이디
            if(option.hasOwnProperty("id"))
                el.id = option.id;

            // 이벤트
            if(option.hasOwnProperty("events")) {
                $shutils.event(el).all(option.events);
            }

            // 클래스
            if(option.hasOwnProperty("classes")) {
                $shutils.class(el).set(option.classes);
            }

            // 속성
            if(option.hasOwnProperty("attrs")) {
                $shutils.attribute(el).all(option.attrs);
            }

            // Property
            if(option.hasOwnProperty("properties")) {
                $shutils.property(el).all(option.properties);
            }

            // 스타일
            if(option.hasOwnProperty("styles")) {
                $shutils.style(el).all(option.styles);
            }

            // 텍스트
            if(option.hasOwnProperty("text")) {
                el.innerText = option.text;
            }

            // HTML
            if(option.hasOwnProperty("html")) {
                el.innerHTML = option.html;
            }
        }
        return el;
    }

    child(el, children) {
        if(! $shutils.isSnnh(el)) el = $sh(el);
        if(! $shutils.isArray(children)) children = Array(children);
        children.forEach(child => {
            for (const ctag in child) {
                el.append($shutils.create(ctag, (child.hasOwnProperty(ctag) ? child[ctag] : {}))).then();
            }
        });
    }
}

class SnnhAttribute {
    _el;
    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    get el() {
        return this._el;
    }

    values() {
        return this.el.getAttributeNames().reduce((acc, name) => {
            return {...acc, [name]: this.el.getAttribute(name)};
        }, {});
    }

    has(key) {
        return this.el.hasAttribute(key);
    }

    get(key) {
        return this.has(key) ? this.el.getAttribute(key) : null;
    }

    set(key, value) {
        this.el.setAttribute(key, value);
        return this;
    }

    delete(key) {
        if(this.has(key)) this.el.removeAttribute(key);
        return this;
    }

    isRemovable(key) {
        return ["checked", "selected", "disabled", "readonly"].indexOf(key.toLowerCase()) >= 0;
    }

    all(datas) {
        switch ( $shutils.type(datas)) {
            case "array":
                datas.forEach(key => {
                    this.delete(key);
                });
                break;
            case "object":
            default:
                for(const key in datas) {
                    const value = datas[key];
                    if(this.isRemovable(key) && !value) {
                        this.delete(key);
                    } else {
                        this.set(key, value);
                    }
                }
                break;
        }
        return this;
    }
}

class SnnhDataset {
    _el;
    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    get el() {
        return this._el;
    }

    get values() {
        return this.el.dataset;
    }

    isAttribute(key) {
        return !!key.match(/^category-+/);
    }

    has(key) {
        if(this.isAttribute(key)) key = this.toKey(key);
        return this.values.hasOwnProperty(key);
    }

    get(key) {
        if(this.isAttribute(key)) key = this.toKey(key);
        return this.has(key) ? this.values[key] : null;
    }

    set(key, value) {
        if(this.isAttribute(key)) key = this.toKey(key);
        this.values[key] = value;
        return this;
    }

    delete(key) {
        if(this.has(key)) delete this.values[key];
        return this;
    }

    all(datas) {
        switch ( $shutils.type(datas)) {
            case "array":
                datas.forEach(key => {
                    this.delete(key);
                });
                break;
            case "object":
            default:
                for(const key in datas) {
                    this.set(key, datas[key]);
                }
                break;
        }
        return this;
    }

    toAttr(str) {
        return "category-" + this.toDash(str);
    }

    toDash(str) {
        return str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
    }

    toKey(str) {
        let key;
        let category = str.split("-");

        for (let i = 0; i < category.length; i++) {
            const value = category[i];
            if(value === "category") continue;
            if (!key) key = category[i].toLowerCase();
            else key += (category[i].charAt(0).toUpperCase() + category[i].slice(1)).toString();
        }
        return key;
    }
}

class SnnhProperty {
    _el;

    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    get el() {
        return this._el;
    }

    has(key) {
        return this.el.hasOwnProperty(key);
    }

    get(key) {
        return this.el[key];
    }

    set(key, value) {
        this.el[key] = value;
        return this;
    }

    delete(key) {
        if(this.has(key)) delete this.el[key];
        return this;
    }

    all(datas) {
        switch ( $shutils.type(datas)) {
            case "array":
                datas.forEach(key => {
                    this.delete(key);
                });
                break;
            case "object":
            default:
                for(const key in datas) {
                    this.set(key, datas[key]);
                }
                break;
        }
        return this;
    }
}

class SnnhClass {
    _el;
    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    get el() {
        return this._el;
    }

    get values() {
        return this.el.classList;
    }

    has(key) {
        return this.values.contains(key);
    }

    toggle(name="on") {
        this.values.toggle(name);
        return this;
    }

    set(names) {
        switch ( $shutils.type(names)) {
            case "array":
                names.forEach(name => {
                    this.values.add(name);
                });
                break;
            default:
                this.values.add(names);
                break;
        }
        return this;
    }

    delete(names) {
        switch ( $shutils.type(names)) {
            case "array":
                names.forEach(name => {
                    this.values.remove(name);
                });
                break;
            default:
                this.values.remove(names);
                break;
        }
        return this;
    }
}

class SnnhStyle {
    _el;
    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    get el() {
        return this._el;
    }

    get values() {
        return this.el.style;
    }

    get(key) {
        return this.values[key];
    }

    set(key, value) {
        this.values[key] = value;
        return this;
    }

    delete(key) {
        delete this.values[key];
        return this;
    }

    all(datas) {
        switch ( $shutils.type(datas)) {
            case "array":
                datas.forEach(key => {
                    this.delete(key);
                });
                break;
            case "object":
            default:
                for(const key in datas) {
                    this.set(key, datas[key]);
                }
                break;
        }
        return this;
    }

    rgba(hex, alpha) {
        const color = this.rgb(hex);
        return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
    }

    rgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    hex(r, g, b) {
        return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
    }
}

class SnnhEvent {
    _el;
    constructor(el) {
        if( $shutils.isSnnh(el)) el = el.get(0);
        this._el = el;
    }

    /**
     *
     * @returns {*}
     */
    get el() {
        return this._el;
    }

    /**
     *
     * @param type {string}
     * @param callback {Function}
     * @param option
     * @returns {SnnhEvent}
     */
    on(type, callback, option={}) {
        if(this.el) {
            this.el.addEventListener(
                type,
                callback,
                option
            );
        }
        return this;
    }

    /**
     *
     * @param type {string}
     * @param callback {Function}
     * @returns {SnnhEvent}
     */
    off(type, callback) {
        if(this.el) {
            this.el.removeEventListener(
                type,
                callback
            );
        }
        return this;
    }

    /**
     * @param event {Event|string}
     * @returns {SnnhEvent}
     */
    trigger(event) {
        if(this.el) {
            this.el.dispatchEvent(
                $shutils.type(event) === "string" ? new Event(event) : event
            );
        }
        return this;
    }

    /**
     * set all event
     * @param datas
     * @returns {SnnhEvent}
     */
    all(datas) {
        for(const key in datas) {
            this.on(key, datas[key]);
        }
        return this;
    }
}

const $shutils = new SnnhUtils();
const snnh_id = "snnh-id";

class $Snnh {
    _ctx = null;
    _elems = [];
    _a = {};
    _d = {};
    _p = {};
    _c = {};
    _s = {};
    _e = {};

    constructor(selector, ctx=null) {
        if(!ctx) ctx = document;
        else if(typeof ctx === 'string') ctx = document.querySelector(ctx);
        if($shutils.isSnnh(ctx)) ctx = ctx.get();
        this._ctx = ctx;
        this._elems = this.find(selector);
    }

    get elems() {
        return this._elems;
    }

    get length() {
        return this.elems.length;
    }

    get(i=0) {
        return this.elems.hasOwnProperty(i)
            ? this.elems[i] : null;
    }

    get attribute() {
        return this.attributeAt(0)
    }

    attributeAt(i) {
        if(!this._a.hasOwnProperty(i))
            this._a[i] = $shutils.attribute(this.get(i));
        return this._a[i];
    }

    get dataset() {
        return this.datasetAt(0)
    }

    datasetAt(i) {
        if(!this._d.hasOwnProperty(i))
            this._d[i] = $shutils.dataset(this.get(i));
        return this._d[i];
    }

    get property() {
        return this.propertyAt(0)
    }

    propertyAt(i) {
        if(!this._p.hasOwnProperty(i))
            this._p[i] = $shutils.property(this.get(i));
        return this._p[i];
    }

    get class() {
        return this.classAt(0)
    }

    classAt(i) {
        if(!this._c.hasOwnProperty(i))
            this._c[i] = $shutils.class(this.get(i));
        return this._c[i];
    }

    get style() {
        return this.styleAt(0)
    }

    styleAt(i) {
        if(!this._s.hasOwnProperty(i))
            this._s[i] = $shutils.style(this.get(i));
        return this._s[i];
    }

    on(type, callback, options={}) {
        if(this.length) {
            this.each(el => {
                el.event.on(type, callback, options)
            });
        }
        return this;
    }

    off(type, callback) {
        if(this.length) {
            this.each(el => {
                el.event.off(type, callback);
            });
        }
        return this;
    }

    get event() {
        return this.eventAt(0)
    }

    eventAt(i) {
        if(!this._e.hasOwnProperty(i)) {
            this._e[i] = $shutils.event(this.get(i));
        }
        return this._e[i];
    }

    eventAll(type, callback) {
        if(this.length) {
            this.each(el => {
                el.event.on(type, (e) => callback.call(this, e))
            });
        }
        return this;
    }

    /**
     * attribute id
     * @returns {*}
     */
    get snnh_id() {
        return this.attribute.get(snnh_id);
    }

    find(selector, idx=undefined) {
        const elements = (typeof selector === "string") ? this._ctx.querySelectorAll(selector) : [selector];
        return idx !== undefined && $shutils.isNumber(idx) ? (elements.hasOwnProperty(idx) ? elements[idx] : null) : elements;
    }

    each(callback) {
        if(this.length > 0) {
            $shutils.each(this.elems, (el, i) => callback.call(this, $sh(el), i));
        }
    }

    focus(i=0) {
        const elem = this.get(i);
        if(elem) elem.focus();
    }

    clear(i=0) {
        try {
            const elem = this.get(i);
            if(elem) {
                while (elem.firstChild)
                    elem.removeChild(elem.firstChild);
                elem.textContent = "";
            }
        } catch (e) {}
        return this;
    }

    remove() {
        this.each(el => {
            if(el.length) el.get().remove();
        });
    }

    get parent() {
        return this.parentAt(0);
    }

    parentAt(i) {
        try {
            const element = this.get(i);
            if(element) return element.parentElement;
        } catch (e) {}
        return null;
    }

    get previous() {
        return this.previousAt(0);
    }

    previousAt(i) {
        try {
            const element = this.get(i);
            if(element) return element.previousSibling;
        } catch (e) {}
        return null;
    }

    get next() {
        return this.nextAt(0);
    }

    nextAt(i) {
        try {
            const element = this.get(i);
            if(element) return element.nextSibling;
        } catch (e) {}
        return null;
    }

    sibling(el, is_next=false) {
        const _ = this;
        return new Promise((resolve, reject) => {
            try {
                const elem = this.get();
                if(!elem) {
                    reject(new Error('el not exists.'));
                    return;
                }

                if($shutils.isSnnh(el)) el = el.get();
                // 이전
                if(!is_next) elem.parentNode.insertBefore(el, elem);
                // 다음
                else elem.parentNode.insertBefore(el, this.next);
                resolve({fn: _, element: el});
            } catch (e) {
                reject(e);
            }
        });
    }

    get text() {
        try {
            return this.get().textContent;
        } catch (e) {
            return '';
        }
    }

    set text(str) {
        this.textAt(0, str);
    }

    textAt(i, str) {
        this.get(i).textContent = str;
    }

    closet(selector) {
        return this.closetAt(0, selector);
    }

    closetAt(i, selector) {
        try {
            return this.get(i).closest(selector);
        } catch (e) {}
        return null;
    }

    append(el) {
        const _ = this;
        return new Promise((resolve, reject) => {
            try {
                const elem = this.get();
                if(!elem) {
                    reject(new Error('el not exists.'));
                    return;
                }

                if(typeof el === "string") {
                    elem.insertAdjacentHTML( 'beforeend', el );
                    resolve({fn: _, element: elem.firstChild});
                } else {
                    if($shutils.isSnnh(el)) el = el.get();
                    elem.append(el);
                    resolve({fn: _, element: el});
                }
            } catch (e) {
                reject(e);
            }
        });
    }

    prepend(el) {
        const _ = this;
        return new Promise((resolve, reject) => {
            try {
                const elem = this.get();
                if(!elem) {
                    reject(new Error('el not exists.'));
                    return;
                }

                if($shutils.isSnnh(el)) el = el.get();
                elem.prepend(el);
                resolve({fn: _, element: el});
            } catch (e) {
                reject(e);
            }
        });
    }

    wrap(el) {
        const _ = this;
        return new Promise((resolve, reject) => {
            try {
                const elem = this.get();
                if(!elem) {
                    reject(new Error('el not exists.'));
                    return;
                }

                if($shutils.isSnnh(el)) el = el.get();
                el.parentNode.insertBefore(elem, el.nextSibling);
                elem.append(el);
                resolve({fn: _, element: el});
            } catch (e) {
                reject(e);
            }
        });
    }
}

const $sh = function(selector, context) {
    return new $Snnh(selector, context);
};

export default $sh;
export { $shutils };


// WEBPACK FOOTER //
// ./src/libs/snnh/snnh.js